import React from 'react';
import Type from 'prop-types';
import {
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@mui/material";
import { Description as DescriptionIcon } from "@mui/icons-material";
import { Link } from 'components';
import { getRelativeDateTime } from 'utils/date';
import { truncateFilename } from 'utils/string';

const FileItem = (props) => {
  const { file } = props;
  const { date: formattedFileUploadDate } = getRelativeDateTime(file.createdAt);

  return (
    <ListItem component={Link} to={file.url} button download>
      <ListItemIcon>
        <DescriptionIcon />
      </ListItemIcon>
      <ListItemText
        primary={truncateFilename(file.filename, 20)}
        secondary={file.author}
        secondaryTypographyProps={{ variant: 'body1' }}
      />
      <ListItemSecondaryAction>
        <Typography color="textSecondary">{formattedFileUploadDate}</Typography>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

FileItem.propTypes = {
  file: Type.shape({
    id: Type.string.isRequired,
    filename: Type.string.isRequired,
    author: Type.string.isRequired,
    createdAt: Type.string.isRequired,
    url: Type.string.isRequired,
  }).isRequired,
};

export default FileItem;
